import React, { useState, useEffect } from 'react';
import { Box, Grid, Button, Typography, TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { postFormData, getData } from '../../ServerRequest';
import LoaderStyleOne from '../../components/LoaderStyleOne';

const UploadProductImage = () => {
    const [productCode, setProductCode] = useState('');
    const [images, setImages] = useState({});
    const [productCodeList, setProductCodeList] = useState([]);
    const [productsData, setProductsData] = useState([]);
    const [productStatus, setProductStatus] = useState('added');

    const [pagination, setPagination] = useState({ current_page: 1, per_page: 10, total: 0 });
    const [loading, setLoading] = useState(true);

    const fetchProducts = async (page = 1) => {
        setLoading(true);
        try {
            const resData = await getData(`/api/product/all?ps_product_status=${productStatus}&page=${page}&per_page=${pagination.per_page}`);
            console.log("API Response:", resData); // Debug response
            const { products = [], pagination: pag = { total_product: 0, total: 0, num_pages: 1, current_page: 1, per_page: 10 } } = resData.data;

            setProductsData(products);
            setProductCodeList(products.map((product) => ({ id: product.id, name: product.ps_product_prodname, code: product.ps_product_productcode })));
        } catch (error) {
            console.error("Error fetching products:", error);
            setPagination({ total: 0, num_pages: 1, current_page: 1, per_page: 10 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, [productStatus]);


    const handleProductCodeChange = (event, newValue) => {
        setProductCode(newValue ? newValue.code : '');
    };

    const handleImageChange = (e) => {
        const { name, files } = e.target;
        setImages((prevImages) => ({
            ...prevImages,
            [name]: files[0],
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData();
        Object.keys(images).forEach((key, index) => {
            formData.append('images', images[key], `${productCode}_${index + 1}`);
        });
        formData.append('product_id', productCode);
        try {
            const response = await postFormData('/api/product/upload-fabric-image', formData);
            if (response.data.code === '200') {

                alert("Images uploaded successfully");
                setLoading(false);
                window.location.reload();
            }
            else {
                alert("Error uploading images");
                setLoading(false);
                window.location.reload();
            }
        } catch (error) {
            alert("Error uploading images");
            setLoading(false);
            window.location.reload();
            console.error('Error uploading images:', error);
        }
    };

    if (loading) {
        return (
            <Box sx={{ width: '97.5%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
                <LoaderStyleOne />
            </Box>
        );
    }
    return (
        <Box sx={{ width: '95%', paddingLeft: 3, mb: 5 }}>
            <Grid container sx={{ flex: 1, height: '100%' }}>
                <Box sx={{ width: '100%', height: '100%' }}>
                    <Box sx={{ border: '2px solid #F4F3F6', p: 3, borderRadius: 0, background: '#f8f9fa' }}>
                        <Typography
                            variant="body1"
                            sx={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 16, mb: 8 }}
                        >
                            Upload Product Images
                        </Typography>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sx={{ mb: 3 }}>
                                    <Typography sx={{ fontSize: 15, fontWeight: 600, mb: 1 }}>Product Code:</Typography>
                                        <Autocomplete
                                            required={true}
                                            id="productCode"
                                            options={productCodeList}
                                            getOptionLabel={(option) => option.name || ''}
                                            value={productCodeList.find((product) => product.code === productCode) || null}
                                            onChange={handleProductCodeChange}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Product"
                                                    variant="outlined"
                                                    fullWidth
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        sx: {
                                                            ...params.InputProps?.sx,
                                                            backgroundColor: '#fff',
                                                            borderRadius: 0,
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                </Grid>
                                {['image1', 'image2', 'image3', 'image4'].map((imageName, index) => (
                                    <Grid item xs={12} sm={6} md={3} lg={3} key={index} sx={{ mb: 3 }}>
                                        <Typography sx={{ fontSize: 15, fontWeight: 600, mb: 1 }}>{`Image ${index + 1}:`}</Typography>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 1,
                                                border: '1px solid #E0E0E0',
                                                borderRadius: 0,
                                                p: 2,
                                                background: '#FFF',
                                            }}
                                        >
                                                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <label htmlFor={`file-input-${imageName}`} style={{ width: '100%' }}>
                                                            <input
                                                                type="file"
                                                                id={`file-input-${imageName}`}
                                                                name={imageName}
                                                                onChange={handleImageChange}
                                                                style={{ display: 'none' }}
                                                            />
                                                            <Button
                                                                variant="outlined"
                                                                component="span"
                                                                sx={{
                                                                    width: '100%',
                                                                    minWidth: 0,
                                                                    maxWidth: '100%',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    borderRadius: 1,
                                                                    fontSize: 14,
                                                                    py: 1,
                                                                    px: 2,
                                                                    color: '#565E6D',
                                                                    borderColor: '#565E6D',
                                                                    '&:hover': {
                                                                        borderColor: '#565E6D',
                                                                        backgroundColor: '#f5f5f5',
                                                                        color: '#565E6D',
                                                                    },
                                                                }}
                                                            >
                                                                {images[imageName]?.name || 'Choose File'}
                                                            </Button>
                                                        </label>
                                                        {images[imageName] && (
                                                            <Box sx={{ mt: 1 }}>
                                                                <img
                                                                    src={URL.createObjectURL(images[imageName])}
                                                                    alt={`Preview ${imageName}`}
                                                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: 4, border: '1px solid #ccc' }}
                                                                />
                                                            </Box>
                                                        )}
                                                    </Box>
                                        </Box>
                                    </Grid>
                                ))}
                                <Grid item xs={12}>
                                    <Button 
                                        type="submit" 
                                        variant="outlined"
                                        sx={{
                                            backgroundColor: "#565E6D",
                                            border: "1px solid #565E6D",
                                            color: "#fff",
                                                "&:hover": { backgroundColor: "#546e7a" },
                                            borderRadius: "0px",
                                        }}>
                                        Upload 
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                </Box>
            </Grid>
        </Box>
    );
};

export default UploadProductImage;